function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", {
  id: "email-plain_svg__defs2"
}, /*#__PURE__*/React.createElement("path", {
  id: "email-plain_svg__rect835",
  d: "M18.669 16.949h156.588v16.527H18.669z"
}));

function SvgEmailPlain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 572.8,
    height: 39.72,
    viewBox: "0 0 151.553 10.509",
    id: "email-plain_svg__svg8"
  }, props), _ref, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-19.028 -18.347)",
    id: "email-plain_svg__layer1",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "email-plain_svg__text833",
    "aria-label": "dxt90.business@gmail.com",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: 10.583,
    fontFamily: "Montserrat",
    letterSpacing: 0,
    wordSpacing: 0,
    fill: "#fff",
    fillOpacity: 1,
    stroke: "none",
    fontVariant: "normal",
    fontStretch: "normal"
  }, /*#__PURE__*/React.createElement("path", {
    id: "email-plain_svg__path855",
    style: {
      InkscapeFontSpecification: "'Montserrat Bold'"
    },
    d: "M25.23 18.823v7.853h-1.577v-.656q-.614.74-1.778.74-.805 0-1.46-.359-.646-.36-1.017-1.026-.37-.667-.37-1.546 0-.878.37-1.545.37-.667 1.016-1.026.656-.36 1.46-.36 1.09 0 1.705.688v-2.763zm-3.07 6.583q.625 0 1.038-.423.412-.434.412-1.154t-.412-1.143q-.413-.434-1.038-.434-.635 0-1.047.434-.413.424-.413 1.143 0 .72.413 1.154.412.423 1.047.423z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "email-plain_svg__path857",
    style: {
      InkscapeFontSpecification: "'Montserrat Bold'"
    },
    d: "M30.367 26.676l-1.249-1.746-1.291 1.746h-1.8l2.191-2.868-2.116-2.826h1.852l1.206 1.662 1.239-1.662h1.756l-2.116 2.784 2.201 2.91z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "email-plain_svg__path859",
    style: {
      InkscapeFontSpecification: "'Montserrat Bold'"
    },
    d: "M36.724 26.401q-.243.18-.603.275-.35.085-.74.085-1.017 0-1.578-.519-.55-.518-.55-1.524V22.38h-.879v-1.27h.879v-1.386h1.65v1.386h1.42v1.27h-1.42v2.318q0 .36.18.561.191.19.53.19.392 0 .667-.211z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "email-plain_svg__path861",
    style: {
      InkscapeFontSpecification: "'Montserrat Bold'"
    },
    d: "M39.833 19.141q1.556 0 2.434.952.878.942.878 2.72 0 1.26-.476 2.16-.465.899-1.323 1.365-.857.465-1.979.465-.592 0-1.132-.127-.54-.137-.92-.38l.634-1.26q.54.37 1.386.37.942 0 1.493-.55.55-.561.592-1.609-.666.667-1.841.667-.71 0-1.291-.286-.582-.285-.921-.804-.339-.53-.339-1.217 0-.741.37-1.302.371-.56 1.006-.857.646-.307 1.429-.307zm.127 3.492q.56 0 .91-.306.36-.318.36-.805 0-.487-.35-.794-.338-.306-.941-.306-.55 0-.9.296-.338.296-.338.804t.338.815q.35.296.92.296z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "email-plain_svg__path863",
    style: {
      InkscapeFontSpecification: "'Montserrat Bold'"
    },
    d: "M47.143 26.803q-.92 0-1.64-.455-.72-.455-1.133-1.312-.402-.868-.402-2.064 0-1.196.402-2.053.413-.868 1.133-1.323.72-.455 1.64-.455.92 0 1.64.455.72.455 1.122 1.323.413.857.413 2.053t-.413 2.064q-.402.857-1.122 1.312-.72.455-1.64.455zm0-1.45q.677 0 1.058-.582.392-.582.392-1.799t-.392-1.8q-.38-.581-1.058-.581-.667 0-1.058.582-.381.582-.381 1.8 0 1.216.38 1.798.392.582 1.059.582z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "email-plain_svg__path865",
    style: {
      InkscapeFontSpecification: "'Montserrat Bold'"
    },
    d: "M51.99 26.76q-.434 0-.73-.295-.296-.297-.296-.741 0-.455.296-.73.296-.286.73-.286t.73.286q.297.275.297.73 0 .444-.296.74-.297.297-.73.297z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "email-plain_svg__path867",
    style: {
      InkscapeFontSpecification: "'Montserrat Bold'"
    },
    d: "M57.501 20.898q.794 0 1.44.37.656.36 1.026 1.027.37.656.37 1.534 0 .879-.37 1.546-.37.656-1.026 1.026-.646.36-1.44.36-1.175 0-1.788-.74v.655h-1.577v-7.853h1.65v2.763q.625-.688 1.715-.688zm-.286 4.508q.635 0 1.038-.423.412-.434.412-1.154t-.412-1.143q-.403-.434-1.038-.434t-1.047.434q-.402.424-.402 1.143 0 .72.402 1.154.412.423 1.047.423z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "email-plain_svg__path869",
    style: {
      InkscapeFontSpecification: "'Montserrat Bold'"
    },
    d: "M67.169 20.982v5.694h-1.567V26q-.328.37-.783.571-.455.19-.984.19-1.122 0-1.778-.645-.656-.645-.656-1.915v-3.218h1.65v2.974q0 1.376 1.154 1.376.593 0 .953-.38.36-.392.36-1.154v-2.816z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "email-plain_svg__path871",
    style: {
      InkscapeFontSpecification: "'Montserrat Bold'"
    },
    d: "M70.624 26.76q-.709 0-1.386-.168-.678-.18-1.08-.445l.55-1.185q.381.243.921.402.54.148 1.059.148 1.047 0 1.047-.518 0-.244-.285-.35-.286-.106-.879-.18-.698-.105-1.153-.243-.456-.138-.794-.487-.328-.35-.328-.995 0-.54.307-.952.317-.424.91-.656.603-.233 1.418-.233.603 0 1.196.137.603.127.995.36l-.55 1.175q-.752-.423-1.641-.423-.53 0-.794.148t-.264.38q0 .265.285.371.286.106.91.201.699.117 1.144.254.444.127.772.477.328.349.328.973 0 .53-.317.942-.318.413-.932.646-.603.222-1.439.222z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "email-plain_svg__path873",
    style: {
      InkscapeFontSpecification: "'Montserrat Bold'"
    },
    d: "M74.33 20.982h1.652v5.694H74.33zm.826-.793q-.455 0-.74-.265-.286-.264-.286-.656t.286-.656q.285-.265.74-.265t.741.254q.286.254.286.635 0 .413-.286.688-.286.265-.74.265z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "email-plain_svg__path875",
    style: {
      InkscapeFontSpecification: "'Montserrat Bold'"
    },
    d: "M80.975 20.898q1.058 0 1.704.635.656.635.656 1.884v3.26h-1.651V23.67q0-.678-.296-1.006-.297-.338-.858-.338-.624 0-.994.391-.37.381-.37 1.143v2.815h-1.652v-5.694h1.577v.667q.328-.36.815-.55.487-.201 1.069-.201z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "email-plain_svg__path877",
    style: {
      InkscapeFontSpecification: "'Montserrat Bold'"
    },
    d: "M90.47 23.85q0 .032-.03.445h-4.308q.116.53.55.836.434.307 1.08.307.444 0 .783-.127.349-.138.645-.423l.879.952q-.805.92-2.35.92-.963 0-1.704-.37-.74-.38-1.143-1.047-.402-.667-.402-1.514 0-.836.392-1.502.402-.678 1.09-1.048.698-.381 1.556-.381.836 0 1.513.36.677.36 1.058 1.037.392.667.392 1.556zm-2.952-1.703q-.56 0-.942.317-.38.318-.465.868h2.804q-.085-.54-.466-.857-.38-.328-.93-.328z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "email-plain_svg__path879",
    style: {
      InkscapeFontSpecification: "'Montserrat Bold'"
    },
    d: "M93.486 26.76q-.71 0-1.387-.168-.677-.18-1.08-.445l.551-1.185q.381.243.92.402.54.148 1.06.148 1.047 0 1.047-.518 0-.244-.286-.35-.286-.106-.878-.18-.699-.105-1.154-.243-.455-.138-.794-.487-.328-.35-.328-.995 0-.54.307-.952.318-.424.91-.656.604-.233 1.419-.233.603 0 1.195.137.604.127.995.36l-.55 1.175q-.751-.423-1.64-.423-.53 0-.794.148-.265.148-.265.38 0 .265.286.371.286.106.91.201.699.117 1.143.254.445.127.773.477.328.349.328.973 0 .53-.318.942-.317.413-.931.646-.603.222-1.44.222z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "email-plain_svg__path881",
    style: {
      InkscapeFontSpecification: "'Montserrat Bold'"
    },
    d: "M99.108 26.76q-.71 0-1.386-.168-.678-.18-1.08-.445l.55-1.185q.381.243.921.402.54.148 1.058.148 1.048 0 1.048-.518 0-.244-.286-.35-.285-.106-.878-.18-.698-.105-1.154-.243-.455-.138-.793-.487-.328-.35-.328-.995 0-.54.307-.952.317-.424.91-.656.603-.233 1.418-.233.603 0 1.196.137.603.127.995.36l-.55 1.175q-.752-.423-1.641-.423-.53 0-.794.148t-.264.38q0 .265.285.371.286.106.91.201.699.117 1.143.254.445.127.773.477.328.349.328.973 0 .53-.317.942-.318.413-.932.646-.603.222-1.439.222z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "email-plain_svg__path883",
    style: {
      InkscapeFontSpecification: "'Montserrat Bold'"
    },
    d: "M107.588 19.162q1.46 0 2.593.603 1.143.593 1.778 1.64.635 1.049.635 2.371 0 .932-.275 1.61-.265.666-.752 1.015-.487.35-1.143.35-.54 0-.91-.233t-.54-.688q-.571.92-1.81.92-.677 0-1.238-.338-.56-.339-.889-.942-.317-.614-.317-1.397 0-.773.317-1.376.328-.614.879-.953.56-.338 1.249-.338 1.047 0 1.63.698v-.624h1.439v3.429q0 .677.508.677.37 0 .571-.444.212-.445.212-1.344 0-1.07-.498-1.884-.486-.826-1.386-1.28-.889-.466-2.053-.466t-2.064.497q-.889.487-1.386 1.355-.487.867-.487 1.968 0 1.122.487 2 .487.868 1.365 1.355.889.497 2.043.497 1.143 0 2.084-.465l.34.973q-.477.244-1.133.37-.646.138-1.291.138-1.503 0-2.657-.635-1.153-.624-1.788-1.735-.635-1.111-.635-2.498 0-1.376.635-2.476.645-1.101 1.81-1.725 1.163-.625 2.677-.625zm-.095 6.371q.582 0 .952-.38.37-.392.37-1.08 0-.678-.37-1.059-.37-.38-.952-.38-.593 0-.953.391-.36.381-.36 1.048 0 .677.36 1.069.36.391.953.391z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "email-plain_svg__path885",
    style: {
      InkscapeFontSpecification: "'Montserrat Bold'"
    },
    d: "M119.644 20.982v4.742q0 1.566-.815 2.328-.815.762-2.381.762-.826 0-1.567-.201-.74-.201-1.227-.582l.656-1.185q.36.296.91.465.55.18 1.1.18.858 0 1.26-.391.413-.381.413-1.165v-.243q-.646.71-1.8.71-.782 0-1.439-.34-.645-.349-1.026-.973-.381-.625-.381-1.44 0-.814.38-1.439.382-.624 1.027-.963.657-.35 1.44-.35 1.238 0 1.884.816v-.73zm-3.122 4.064q.656 0 1.069-.38.423-.392.423-1.017 0-.624-.423-1.005-.413-.392-1.07-.392-.655 0-1.079.392-.423.381-.423 1.005 0 .625.423 1.016.424.381 1.08.381z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "email-plain_svg__path887",
    style: {
      InkscapeFontSpecification: "'Montserrat Bold'"
    },
    d: "M128.462 20.898q1.069 0 1.693.635.635.624.635 1.884v3.26h-1.65V23.67q0-.678-.286-1.006-.275-.338-.794-.338-.582 0-.92.38-.34.37-.34 1.112v2.857h-1.65v-3.005q0-1.344-1.08-1.344-.571 0-.91.38-.339.37-.339 1.112v2.857h-1.65v-5.694h1.576v.657q.318-.36.773-.55.465-.191 1.016-.191.603 0 1.09.243.487.233.783.688.35-.444.878-.688.54-.243 1.175-.243z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "email-plain_svg__path889",
    style: {
      InkscapeFontSpecification: "'Montserrat Bold'"
    },
    d: "M134.567 20.898q1.323 0 2.032.635.709.624.709 1.894v3.25h-1.545v-.71q-.466.794-1.736.794-.656 0-1.143-.222-.476-.223-.73-.614-.254-.392-.254-.89 0-.793.593-1.248.603-.455 1.852-.455h1.312q0-.54-.328-.826-.328-.296-.984-.296-.455 0-.9.148-.434.138-.74.381l-.593-1.153q.465-.328 1.11-.508.657-.18 1.345-.18zm-.127 4.752q.423 0 .751-.19.328-.202.466-.583v-.582h-1.132q-1.016 0-1.016.667 0 .317.243.508.254.18.688.18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "email-plain_svg__path891",
    style: {
      InkscapeFontSpecification: "'Montserrat Bold'"
    },
    d: "M138.802 20.982h1.651v5.694h-1.65zm.826-.793q-.455 0-.741-.265-.286-.264-.286-.656t.286-.656q.286-.265.74-.265.456 0 .741.254.286.254.286.635 0 .413-.286.688-.285.265-.74.265z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "email-plain_svg__path893",
    style: {
      InkscapeFontSpecification: "'Montserrat Bold'"
    },
    d: "M141.985 18.823h1.651v7.853h-1.65z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "email-plain_svg__path895",
    style: {
      InkscapeFontSpecification: "'Montserrat Bold'"
    },
    d: "M145.793 26.76q-.434 0-.73-.295-.297-.297-.297-.741 0-.455.297-.73.296-.286.73-.286t.73.286q.297.275.297.73 0 .444-.297.74-.296.297-.73.297z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "email-plain_svg__path897",
    style: {
      InkscapeFontSpecification: "'Montserrat Bold'"
    },
    d: "M150.607 26.76q-.91 0-1.64-.37-.72-.38-1.132-1.047-.403-.667-.403-1.514 0-.846.403-1.513.412-.667 1.132-1.037.73-.381 1.64-.381.9 0 1.567.38.677.371.984 1.07l-1.28.688q-.445-.784-1.281-.784-.646 0-1.069.424-.423.423-.423 1.153t.423 1.154q.423.423 1.069.423.847 0 1.28-.783l1.281.699q-.307.677-.984 1.058-.667.38-1.567.38z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "email-plain_svg__path899",
    style: {
      InkscapeFontSpecification: "'Montserrat Bold'"
    },
    d: "M156.746 26.76q-.9 0-1.62-.37-.709-.38-1.11-1.047-.403-.667-.403-1.514 0-.846.402-1.513.402-.667 1.111-1.037.72-.381 1.62-.381.9 0 1.608.38.71.371 1.112 1.038.402.667.402 1.513 0 .847-.402 1.514-.403.667-1.112 1.048-.709.37-1.608.37zm0-1.354q.635 0 1.037-.423.413-.434.413-1.154t-.413-1.143q-.402-.434-1.037-.434-.635 0-1.048.434-.413.424-.413 1.143 0 .72.413 1.154.413.423 1.048.423z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "email-plain_svg__path901",
    style: {
      InkscapeFontSpecification: "'Montserrat Bold'"
    },
    d: "M168.253 20.898q1.069 0 1.693.635.635.624.635 1.884v3.26h-1.65V23.67q0-.678-.287-1.006-.275-.338-.793-.338-.582 0-.921.38-.339.37-.339 1.112v2.857h-1.65v-3.005q0-1.344-1.08-1.344-.572 0-.91.38-.34.37-.34 1.112v2.857h-1.65v-5.694h1.577v.657q.317-.36.772-.55.466-.191 1.016-.191.604 0 1.09.243.487.233.784.688.349-.444.878-.688.54-.243 1.175-.243z"
  }))));
}

export default __webpack_public_path__ + "static/email-plain.087a32cf.svg";
export { SvgEmailPlain as ReactComponent };